export function getVerbs(signupListTypeID) {
  switch (signupListTypeID) {
    case 1:
      return {
        entity: "spot",
        entityPlural: "spots",
      };
    case 2:
      return {
        entity: "seat",
        entityPlural: "seats",
      };
    case 4:
      return {
        entity: "vote",
        entityPlural: "votes",
      };
    case 5:
      return {
        entity: "item",
        entityPlural: "items",
      };
    case 7:
      return {
        entity: "spot",
        entityPlural: "spots",
      };
    default:
      return {
        entity: "spot",
        entityPlural: "spots",
      };
  }
}
